(function(){
  const grid = document.getElementById('armGrid');
  const filterGroup = document.getElementById('armFilterGroup');
  const sort = document.getElementById('armSort');
  if(!grid) return;

  const cards = Array.from(grid.querySelectorAll('.arm-card'));
  const soldOutLast = grid.dataset.soldOutLast === 'true';

  // Compteur localisé selon la langue réellement affichée.
  const countEl = document.querySelector('.arm-item-count');
  let countCopy = {};
  try { countCopy = JSON.parse(document.getElementById('SvhaineLocalizationContext').textContent).ui || {}; } catch (_) {}

  function updateCount(){
    if(!countEl) return;
    const n = cards.filter(c => c.style.display !== 'none').length;
    if (countCopy.item_one && countCopy.item_other) countEl.textContent = n + ' ' + (n === 1 ? countCopy.item_one : countCopy.item_other);
  }

  function applyFilter(type){
    cards.forEach(c=>{
      const t = (c.dataset.type || '').trim();
      if(type === 'all' || t === type){
        c.style.display = '';
      }else{
        c.style.display = 'none';
      }
    });
    updateCount();
  }

  function applySort(mode){
    const visible = cards.filter(c => c.style.display !== 'none');
    const hidden = cards.filter(c => c.style.display === 'none');

    const byPrice = (a,b)=> (parseInt(a.dataset.price||'0',10) - parseInt(b.dataset.price||'0',10));
    const byTitle = (a,b)=> (String(a.dataset.title||'').localeCompare(String(b.dataset.title||'')));
    const byAvailability = (a,b)=>{
      if(!soldOutLast) return 0;
      const aSoldOut = a.classList.contains('is-sold-out') ? 1 : 0;
      const bSoldOut = b.classList.contains('is-sold-out') ? 1 : 0;
      return aSoldOut - bSoldOut;
    };
    const keepSoldOutLast = compare => (a,b)=> byAvailability(a,b) || compare(a,b);

    if(mode === 'price-asc') visible.sort(keepSoldOutLast(byPrice));
    if(mode === 'price-desc') visible.sort(keepSoldOutLast((a,b)=> -byPrice(a,b)));
    if(mode === 'title-asc') visible.sort(keepSoldOutLast(byTitle));
    if(mode === 'title-desc') visible.sort(keepSoldOutLast((a,b)=> -byTitle(a,b)));

    // mode "featured" : l'ordre Liquid d'origine est restauré.
    // Sur ACCESSOIRES, cet ordre place déjà les produits épuisés à la fin.
    [...visible, ...hidden].forEach(c=> grid.appendChild(c));
  }

  if(filterGroup){
    filterGroup.addEventListener('click', (e)=>{
      const btn = e.target.closest('button[data-filter]');
      if(!btn) return;
      filterGroup.querySelectorAll('.arm-filter-btn').forEach(b=> b.classList.remove('is-active'));
      btn.classList.add('is-active');
      applyFilter(btn.dataset.filter);
    });
  }

  if(sort){
    sort.addEventListener('change', ()=> applySort(sort.value));
  }

  updateCount();
})();

// Le sélecteur langue/devise est géré une seule fois par assets/svhaine-shop.js.
// Ne pas ajouter ici un second handler sur .svhaine-dd : sinon le menu s'ouvre
// puis se referme immédiatement sur la page ACCESSOIRES.

